import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProfileListComponent } from './profile-list/profile-list.component';
import { ProfileFormComponent } from './profile-form/profile-form.component';
import { EditPhotoComponent } from './edit-photo/edit-photo.component';
import { AccountSecurityComponent } from './account-security/account-security.component';
import { UserSubscriptionsComponent } from './user-subscriptions/user-subscriptions.component';
import { PaymentMethodComponent } from './payment-method/payment-method.component';
import { NotificationComponent } from './notification/notification.component';
import { CloseAccountComponent } from './close-account/close-account.component';
import { UniversalStorageService } from '../../services/universal-storage.service';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent {
    // displayedComponent: any;
    componentName: string;
    selectedItem: string;
    isUserLoggedIn = false;

    constructor(
        private route: ActivatedRoute,
        private storageService: UniversalStorageService
    ) {
        this.route.queryParams.subscribe((queryParams) => {
            this.componentName = queryParams['component'];
            // this.displayedComponent =
            this.getComponentByName(this.componentName);
        });

        const token = this.storageService.getItem('BEARER_TOKEN'); // Replace with your token storage mechanism
        if (token) {
            this.isUserLoggedIn = true;
        }
    }

    private getComponentByName(componentName: string) {
        // Map component names to their classes (e.g., 'ProfileForm' to ProfileFormComponent)
        switch (componentName) {
            case 'user/user-profile/list':
                return ProfileListComponent;

            case 'user/user-profile/edit-profile':
                return ProfileFormComponent;

            case 'user/user-profile/edit-photo':
                return EditPhotoComponent;

            case 'user/user-profile/edit-account':
                return AccountSecurityComponent;

            case 'user/manage-subscriptions':
                return UserSubscriptionsComponent;

            case 'user/user-profile/edit-payment-methods':
                return PaymentMethodComponent;

            case 'user/user-profile/edit-notifications':
                return NotificationComponent;
            case 'user/user-profile/close-account':
                return CloseAccountComponent;
            // Add more cases for other components as needed
            default:
                return ProfileFormComponent; // Default to ProfileListComponent
        }
    }
}
